import React from 'react';
import styles from '../TradeFlowTrackingTab.module.css';
import {
  FetchSession,
  FetchSessionsParams,
  getFetchSessions,
} from '../../../services/tradeFlowAdminApi';
import { useFlowData } from '../hooks/useTradeFlowData';
import DataSection from './DataSection';

interface FetchSectionProps {
  dateFrom: string;
  dateTo: string;
  symbol: string;
}

const FetchSection: React.FC<FetchSectionProps> = ({ dateFrom, dateTo, symbol }) => {
  const params: FetchSessionsParams = {
    date_from: dateFrom || undefined,
    date_to: dateTo || undefined,
    symbol: symbol || undefined,
  };

  const { data, total, page, setPage, isLoading, isFetching, isError, error, totalPages } =
    useFlowData<FetchSession, FetchSessionsParams>({
      queryKeyBase: ['admin', 'trade-flow', 'fetch'],
      fetchFn: (p) => getFetchSessions(p).then((r) => r),
      params,
      refetchInterval: 10000,
    });

  return (
    <DataSection
      title="Platform Fetch Sessions"
      tabNumber={1}
      description="Each session represents one fetch cycle from an exchange API. Click a session to see which symbols were retrieved."
      loading={isLoading}
      isFetching={isFetching}
      error={error?.message || null}
      dataCount={data.length}
      emptyMessage="No fetch sessions found for the selected filters."
      page={page}
      totalPages={totalPages}
      total={total}
      onPageChange={setPage}
    >
      <table className={styles.dataTable}>
        <thead>
          <tr>
            <th>Session ID</th>
            <th>Fetched At</th>
            <th>Provider</th>
            <th>Pairs</th>
            <th>Symbols</th>
          </tr>
        </thead>
        <tbody>
          {data.map((session) => (
            <tr key={session.session_id}>
              <td className={styles.mono}>{session.session_id}</td>
              <td>{session.fetched_at ? new Date(session.fetched_at).toLocaleString() : '-'}</td>
              <td>{session.provider || '-'}</td>
              <td>
                <span className={styles.badge}>{session.pair_count}</span>
              </td>
              <td>
                <div className={styles.symbolList}>
                  {session.symbols.slice(0, 8).map((s, idx) => (
                    <span key={`${s}-${idx}`} className={styles.symbolChip}>{s}</span>
                  ))}
                  {session.symbols.length > 8 && (
                    <span className={styles.symbolChip}>
                      +{session.symbols.length - 8} more
                    </span>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </DataSection>
  );
};

export default FetchSection;
